import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

import { profileApi, type ProfileUpdateRequest } from '../services/profile_api';
import type { User } from '../types/auth';

export const SYNC_TIMEZONE_MUTATION_KEY = ['syncTimezone'] as const;

export const useSyncTimezone = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: SYNC_TIMEZONE_MUTATION_KEY,
    mutationFn: (timezone: string) => profileApi.updateProfile({ timezone }),
    onSuccess: (response) => {
      queryClient.setQueryData<User>(['currentUser'], response.user);
    },
  });
};

export const useUpdateProfile = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('common');

  return useMutation({
    mutationFn: (data: ProfileUpdateRequest) => profileApi.updateProfile(data),
    onSuccess: (response) => {
      queryClient.setQueryData<User>(['currentUser'], response.user);
      toast.success(t('messages.profileUpdated'));
    },
    onError: () => {
      toast.error(t('messages.failedToUpdateProfile'));
    },
  });
};
